// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lx_a","toggleWrap":"styles_toggleWrap__1zizZ","content":"styles_content__3TwrM","selectAreaCode":"styles_selectAreaCode__2ejMK"};